import _ from "lodash";

// Monitor the time since the object was created
export class ElapsedTime
{
    startTime: number;

    constructor(startTime?: number|Date){

        if (_.isDate(startTime))
        {
            this.startTime = startTime.getDate();
            return;
        }
        this.startTime = startTime ?? this.now();
    }

    private now(): number {
        return Date.now();
    }

    // Get the time in milli seconds since the object was created
    public get MilliSeconds() : number {
        return this.now() - this.startTime;
    }

    // Get the time in seconds since the object was created
    public get Seconds() : number {
        return (this.now() - this.startTime)/1000;
    }

}